/**
 * PublicLibraryBanner — persistent banner shown when viewing a page
 * in a public-visibility library. Warns that content is visible to all team members
 * and indicates whether they have read-only or edit access.
 */

import React from 'react';

interface PublicLibraryBannerProps {
  readonly visible: boolean;
  readonly readOnly?: boolean;
}

export function PublicLibraryBanner({ visible, readOnly }: PublicLibraryBannerProps): React.ReactElement | null {
  if (!visible) return null;

  return (
    <div
      className="bg-yellow-50 border border-yellow-200 rounded-md px-4 py-2 text-sm text-yellow-800 flex items-center gap-2"
      role="alert"
      aria-live="polite"
    >
      <span className="text-yellow-600" aria-hidden="true">&#9888;</span>
      {readOnly ? (
        <p>
          This page is in a public library. You have <strong>read-only</strong> access.
          Contact a library admin to request edit permissions.
        </p>
      ) : (
        <p>
          This page is in a public library and is visible to all team members.
          Create a private library for restricted content.
        </p>
      )}
    </div>
  );
}
